export default __webpack_public_path__ + "static/media/gobierno.8bfa5377.jpeg";